import { DataValidator, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

export interface KuaishouVideoPublishRequest {
  brief: string;
  coverUrl: string;
  fileUrl: string;
  thirdAccountIds: string[];
}

export interface KuaishouVideoPublishResponse {
  videoId: string;
}

class KuaishouVideoPublishData {
  @IsString("Video id must be a string")
  videoId: string;
}

const transformAndValidateData = (
  response: KuaishouVideoPublishResponse
): KuaishouVideoPublishData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KuaishouVideoPublishData);
  } catch (error) {
    console.error("Kuaishou video publish data validation failed:", error.message);
    throw error;
  }
};

// 快手发布视频
export const kuaishouVideoPublish = async ({
  brief,
  coverUrl,
  fileUrl,
  thirdAccountIds,
}: KuaishouVideoPublishRequest) => {
  const res = await api.post<KuaishouVideoPublishResponse>("/kuaishou/video/publish", {
    brief,
    coverUrl,
    fileUrl,
    thirdAccountIds,
  });
  return transformAndValidateData(res.data);
};
